import { render, staticRenderFns } from "./product_vnbkcd.vue?vue&type=template&id=3bf0f6a6&scoped=true"
import script from "./product_vnbkcd.vue?vue&type=script&lang=js"
export * from "./product_vnbkcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0f6a6",
  null
  
)

export default component.exports